import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

export interface Partner {
  name: string;
  logo: string;
  website?: string;
}

@Component({
  selector: 'app-partners',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './partners.component.html',
  styleUrl: './partners.component.scss',
})

// POCRA Link: 

// IISc Link:

// Dep of Agri: 
export class PartnersComponent {
  partners: Partner[] = [
    
    {
      name: 'Government of Maharashtra',
      logo: '/partner-logo/Seal_of_Maharashtra (1) 2.svg',
      website: 'https://home.maharashtra.gov.in/en/'
    },
    {
      name: 'Krishi Department',
      logo: '/partner-logo/WhatsApp Image 2025-12-01 at 14.34.45 2.svg',
      website: 'https://krishi.maharashtra.gov.in/'
    },
    {
      name: 'Government Seal',
      logo: '/new_pocra.png',
      website: 'https://mahapocra.gov.in/en'
    },
    {
      name: 'AIAIC',
      logo: '/partner-logo/AIAIC Logo 2 1.svg',
      website: 'https://aiaic.maharashtra.gov.in/'
    },
    // {
    //   name: 'The World Bank',
    //   logo: '/partner-logo/world-bank.png',
    //   website: 'https://www.worldbank.org/ext/en/home'
    // },
    // {
    //   name: 'IISC',
    //   logo: '/iisc.jpg',
    //   website: 'https://dataforpublicgood.org.in/'
    // },
    // {
    //   name: 'CDPG',
    //   logo: '/cdpg.svg',
    //   website: 'https://dataforpublicgood.org.in/'
    // },
    
   
    
   
  ];
}

